/** SA5 — catálogo del inventario Super Admin (espejo de core/admin_inventory.py). */

export const INVENTORY_TABS = [
  { key: 'properties', label: 'Propiedades', tip: 'Inventario inmobiliario de agencias. Solo se mira, no se edita.' },
  { key: 'developments', label: 'Desarrollos', tip: 'Torres y conjuntos. Informativo: no se tocan unidades ni el cerebro.' },
];

export const PROPERTY_TYPES = [
  { value: 'casa', label: 'Casa' },
  { value: 'departamento', label: 'Departamento' },
  { value: 'terreno', label: 'Terreno' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'local', label: 'Local' },
];

export const DEVELOPMENT_TYPES = [
  { value: 'edificio', label: 'Edificio' },
  { value: 'torre', label: 'Torre' },
  { value: 'conjunto', label: 'Conjunto' },
  { value: 'fraccionamiento', label: 'Fraccionamiento' },
  { value: 'residencial', label: 'Residencial' },
];

export function adsPanelVisible(slots) {
  return Array.isArray(slots) && slots.length > 0;
}
